module.exports = "pegasus/assets/blocks/social-1-theme2.png";